<script setup lang="ts">
  import type { PopoverContentEmits, PopoverContentProps } from 'reka-ui';
  import type { HTMLAttributes } from 'vue';
  import { reactiveOmit } from '@vueuse/core';
  import { PopoverContent, PopoverPortal, useForwardPropsEmits } from 'reka-ui';
  import { cn } from '@/shared/lib/utils';

  defineOptions({
    inheritAttrs: false,
  });

  const props = withDefaults(
    defineProps<
      PopoverContentProps & {
        class?: HTMLAttributes['class'];
        disablePortal?: boolean;
        disableAnimations?: boolean;
      }
    >(),
    {
      align: 'center',
      sideOffset: 4,
      disablePortal: false,
      disableAnimations: false,
    }
  );
  const emits = defineEmits<PopoverContentEmits>();

  const delegatedProps = reactiveOmit(props, 'class', 'disablePortal', 'disableAnimations');

  const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
  <PopoverPortal :disabled="props.disablePortal">
    <PopoverContent
      data-slot="popover-content"
      v-bind="{ ...$attrs, ...forwarded }"
      :class="
        cn(
          'bg-popover text-popover-foreground z-50 w-72 rounded-md border p-4 shadow-md origin-(--reka-popover-content-transform-origin) outline-hidden',
          !props.disableAnimations &&
            'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
          props.class
        )
      "
    >
      <slot />
    </PopoverContent>
  </PopoverPortal>
</template>
